<div
  class="file-list"
  [class.file-list--dragging]="isDragging()">
  <div class="file-list__progress">
    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>

  <actions-bar
    class="file-list__actions"
    [attr.aria-hidden]="selected().length <= 0 || null"
    [items]="selected()"
    [isTrash]="isTrash()"
    (moveItemsTo)="broadcast('moveItemsTo', $event)"
    (copyItemsTo)="broadcast('copyItemsTo', $event)"
    (downloadItems)="broadcast('downloadItems', $event)"
    (deleteItems)="broadcast('deleteItems', $event)"
    (deleteItemsPermanently)="broadcast('deleteItemsPermanently', $event)"
    (restoreItems)="broadcast('restoreItems', $event)"
    (clearSelection)="clearSelection()" />

  <div
    class="file-list__table"
    [file-drop]="!isTrash() && (PERMISSIONS.STORAGE_CREATE_UPDATE | permission)"
    (filesUpload)="filesUpload.emit($event)">
    @if (PERMISSIONS.STORAGE_READ | permission) {
      @if (isListEmpty()) {
        <div class="file-list__empty-list">
          <ng-content select="[empty-list]" />
        </div>
      } @else {
        <mat-table
          matSort
          cdkDropList
          cdkDropListSortingDisabled
          [dataSource]="dataSource"
          (cdkDropListDropped)="onItemDropped($event)"
          (matSortChange)="onSortChanged($event)"
          (scroll)="onScroll($event)">
          <!-- Select Column -->
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <evc-input
                type="checkbox"
                [checked]="isAllItemsSelected()"
                [indeterminate]="isSomeItemsSelected()"
                (change)="onSelectAll($event)" />
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <evc-input
                type="checkbox"
                [class]="`checkbox__${isSomeItemsSelected() ? 'visible' : 'hidden'}`"
                [checked]="isItemSelected(element)"
                (change)="onRowSelect(element, $event)"
                (click)="$event.stopPropagation()"
                (dblclick)="$event.stopPropagation()" />
            </mat-cell>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'list.headers.name.sort' | translate">
              {{ 'list.headers.name.label' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              @if (hasProgress(element)) {
                <!-- show spinner ? never displayed while in progress -->
              }
              <drive-file-item [file]="element" />
            </mat-cell>
          </ng-container>
          <!-- Updated Column -->
          <ng-container matColumnDef="updatedAt">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'list.headers.updatedAt.sort' | translate">
              {{ 'list.headers.updatedAt.label' | translate }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [ngClass]="{ 'file-list--disabled': element.isLocked }">
              {{ element.updatedAt | dateFormat }}
            </mat-cell>
          </ng-container>
          <!-- Size Column -->
          <ng-container matColumnDef="size">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'list.headers.size.sort' | translate">
              {{ 'list.headers.size.label' | translate }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [ngClass]="{ 'file-list--disabled': element.isLocked }">
              {{
                element.latestVersion?.sizeInBytes
                  ? (element.latestVersion.sizeInBytes | filesize)
                  : '-'
              }}
            </mat-cell>
          </ng-container>
          <!-- Parent Column -->
          <ng-container matColumnDef="parent">
            <mat-header-cell *matHeaderCellDef>
              {{ 'list.headers.parent.label' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <evc-button
                class="selection__clear"
                icon="folder-move-to"
                (click)="goToParent(element)"
                size="small"
                frame="none" />
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="parentName">
            <mat-header-cell *matHeaderCellDef>
              {{ 'list.headers.parentName.label' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="overflow">
                {{ element.parentNameUponDeletion }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              @if (hasContextMenuActionsForItem(element)) {
                <evc-button
                  size="small"
                  icon="context-menu"
                  frame="none"
                  (click)="onMoreOptionsClick(element, $event)">
                </evc-button>
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            cdkDrag
            [cdkDragData]="itemsForDrag(row)"
            [attr.data-folder-id]="isFolder(row) ? row.id : null"
            [ngClass]="{
              'dnd-file': isFile(row),
              'dnd-folder': isFolder(row),
              'dnd-dragged': IsItemBeingDragged(row),
              selected: isItemSelected(row),
            }"
            (dblclick)="onRowDoubleClick(row)"
            (click)="onRowClick(row, $event)"
            (ctrl-click)="onRowCtrlClick(row)"
            (contextmenu)="onRowRightClick(row, $event)"
            (cdkDragStarted)="onDragStarted(row)"
            (cdkDragEnded)="onDragEnded()">
            <ng-template cdkDragPreview>
              @let draggedCount = draggedItems().length;
              @let isMultiple = draggedCount > 1;

              <div class="drag-item">
                <evc-icon
                  class="drag-item__icon"
                  [file]="isMultiple ? 'file' : getFileIcon(row)"
                  size="md" />
                @if (isMultiple) {
                  <evc-icon
                    class="drag-item__icon drag-item__icon__extra"
                    file="file"
                    size="sm" />
                }
                <div class="drag-item__name">
                  @if (isMultiple) {
                    {{ draggedCount }} {{ 'list.items' | translate }}
                  } @else {
                    {{ row.name }}
                  }
                </div>
              </div>
            </ng-template>
          </mat-row>
        </mat-table>
      }
    } @else {
      <div class="file-list__empty-list">
        <drive-no-item
          empty-list
          sectionCategory="noAccess" />
      </div>
    }

    <div
      class="file-list__drop-overlay"
      aria-hidden="true">
      <img
        class="file-list__drop-overlay-image"
        src="assets/images/ill-file-drop.png"
        [alt]="'list.menu.uploadFilesIconAlt' | translate" />
      <evc-status-indicator
        [text]="'list.menu.uploadFiles' | translate"
        status="neutral"
        [upperCase]="false" />
    </div>
  </div>
</div>

@if (contextMenuOpen()) {
  <evc-menu
    class="file-list__context-menu"
    placement="bottom-end"
    [isOpen]="true"
    [evcAnchoredPosition]="contextMenuAnchor()!"
    [items]="contextMenuConfig().items ?? []"
    (closed)="closeContextMenu()" />
}
